import { render, staticRenderFns } from "./district-form.vue?vue&type=template&id=ae6d23fc&"
import script from "./district-form.vue?vue&type=script&lang=js&"
export * from "./district-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports